<app-modal [isOpen]="isOpen()" (closeModal)="close()" size="xl">
  <ng-container header>What's New</ng-container>

  <div body class="space-y-4">
    @for (note of notes(); track note.id) {
      <div>
        <div class="flex items-baseline justify-between gap-2">
          <span class="font-semibold text-gray-900 dark:text-white">{{ note.title | titlecase }}</span>
          <span class="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">{{ note.id | date:'MMM d, y':'UTC' }}</span>
        </div>
        @if (isArray(note.body)) {
          <ul class="list-disc list-inside text-sm text-gray-700 dark:text-gray-400 mt-1">
            @for (item of note.body; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        } @else {
          <p class="text-sm text-gray-700 dark:text-gray-400 mt-1">{{ note.body }}</p>
        }
      </div>
    }
  </div>

  <div footer class="text-right">
    <app-button (click)="close()">OK</app-button>
  </div>
</app-modal>
